var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "transactionHistory" },
    _vm._l(_vm.transactionItems, function (transaction) {
      return _c(
        "router-link",
        {
          key: transaction.id,
          staticClass: "transactionHistory_item cursor-pointer",
          attrs: {
            tag: "li",
            to: {
              name: "payments.show",
              params: {
                bookingId: transaction.payments[0].booking_id,
                paymentId: transaction.payments[0].id,
                action: "view",
              },
            },
          },
        },
        [
          _c("div", { staticClass: "transactionHistory_sidebar" }, [
            _c("div", { staticClass: "transactionHistory_date" }, [
              _vm._v(
                _vm._s(
                  _vm._f("dateTimezone")(
                    transaction.date,
                    _vm.$user.timezone,
                    _vm.$user.date_format_preference,
                    true
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "transactionHistory_paidLabel label label-success",
              },
              [_vm._v("Paid")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "transactionHistory_main" }, [
            _c("div", { staticClass: "transactionHistory_header" }, [
              _c("h3", [_vm._v(_vm._s(transaction.info.name))]),
              _vm._v(" "),
              _c("div", { staticClass: "transactionHistory_price" }, [
                _vm._v(_vm._s(_vm._f("currency")(transaction.amount))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(transaction.info.description))]),
            _vm._v(" "),
            transaction.receipt_url
              ? _c("div", { staticClass: "transactionHistory_receiptLink" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: transaction.receipt_url,
                        target: "_blank",
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-file-alt" }),
                      _vm._v("\n          View Receipt\n        "),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }